export default __webpack_public_path__ + "static/media/profile_pic_2.19d21948.png";